import React from "react";
import { useLocation } from "react-router-dom";
import {
  AVAILABLE,
  COMMON,
  LEGENDARY,
  MYTHICAL,
  PROCESSING,
  RARE,
  SPECIAL,
  UNCOMMON,
  RESERVE,
} from "../../utils/constants/colors";
import { btnInfoIcon, btnFaqIcon } from "../../assets";

const Info = () => {
  const { pathname } = useLocation();
  return (
    <div className="filter-info">
      <div className="dropown rarityDropdown">
        <button
          className="custom-btn black-bg icon md dropdown-toggle"
          type="button"
          id="rarityDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <img src={btnInfoIcon} alt="" />
        </button>
        <div className="dropdown-menu" aria-labelledby="rarityDropdown">
          <ul>
            <li>
              <span
                className="rarity"
                style={{ backgroundColor: AVAILABLE }}
              ></span>
              Available
            </li>
            <li>
              <span
                className="rarity"
                style={{ backgroundColor: RESERVE }}
              ></span>
              Reserve
            </li>
            <li>
              <span
                className="rarity"
                style={{ backgroundColor: PROCESSING }}
              ></span>
              Processing
            </li>
            <li>
              <span
                className="rarity"
                style={{ backgroundColor: COMMON }}
              ></span>
              Common
            </li>
            <li>
              <span
                className="rarity"
                style={{ backgroundColor: UNCOMMON }}
              ></span>
              Uncommon
            </li>
            <li>
              <span className="rarity" style={{ backgroundColor: RARE }}></span>
              Rare
            </li>
            <li>
              <span
                className="rarity"
                style={{ backgroundColor: SPECIAL }}
              ></span>
              Special
            </li>
            <li>
              <span
                className="rarity"
                style={{ backgroundColor: LEGENDARY }}
              ></span>
              Legendary
            </li>
            {pathname === "/monsterzone" && (
              <li>
                <span
                  className="rarity"
                  style={{ backgroundColor: MYTHICAL }}
                ></span>
                Mythical
              </li>
            )}
          </ul>
        </div>
      </div>
      <button
        className="custom-btn icon-btn md black-bg faqLink"
        onClick={() => window.open("/monsterzone/faqs", "_blank")}
      >
        <img src={btnFaqIcon} alt="" />
        <span className="btn-txt">FAQs</span>
      </button>
    </div>
  );
};

export default Info;
